import React, {Component} from 'react';
import PropTypes from "prop-types";
import Accordion from '../../components/accordion';
import {convertPipeToBrTag} from "../../utils";
import BodyControl from "../../components/body";
import {WINDOW, DOCUMENT} from '../../constants/environment'

/**
 * SubNavigationMb
 */
class SubNavigationMb extends Component {
  static propTypes = {
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    carsTitle: PropTypes.bool,
    rootLink: PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
    }),
    estimationHistory: PropTypes.arrayOf(PropTypes.node),
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      nestedNavigation: PropTypes.object,
    })),
    hierarchy: PropTypes.number,
    deleteRootPageLink: PropTypes.bool,
  };
  static defaultProps = {
    pcTitle: null,
    mbTitle: null,
    carsTitle: null,
    rootLink: null,
    estimationHistory: null,
    links: null,
    hierarchy: null,
    deleteRootPageLink: false,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: false,
      height: 0,
      estimationHistoryOpen: false,
    };
    this.open = false;
    //this.bodyControl = new BodyControl();
  }

  componentDidMount() {
    this.setEstimateCount();
    WINDOW.addEventListener('resize', this.onResize);
    WINDOW.addEventListener('scroll', this.onScroll);
    this.triggerEvent(WINDOW, 'scroll');
  }

  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.onResize);
    WINDOW.removeEventListener('scroll', this.onScroll);
  }

  onResize = (e) => {
    this.handleResize();
    this.fit();
  };

  onScroll = (e) => {
    this.fit();
  };

  onTouchMove = (e) => {
    e.preventDefault();
  };

  fit = () => {
    const scrollTop = DOCUMENT.documentElement.scrollTop || DOCUMENT.body.scrollTop;
    const subNavigation = DOCUMENT.querySelector('.SubNavigation');

    let subNavigationHeight = subNavigation.clientHeight;
    let headerHeight = 0;

    if (subNavigation.classList.contains('fixed')) {
      headerHeight = 0;
    }
    else {
      if (DOCUMENT.querySelector('.Header') && DOCUMENT.querySelector('.Header').clientHeight) {
        headerHeight = DOCUMENT.querySelector('.Header').clientHeight - scrollTop;
      }
    }

    const estimationHistory = this.refs.estimationHistory;

    if (estimationHistory && this.validEstimateJson()) {
      estimationHistory.style.height = (WINDOW.innerHeight - headerHeight) + 'px';
    }

  };

  onClickEstimationHistory = (e) => {
    const isOpen = !this.state.estimationHistoryOpen;
    this.setState({
      estimationHistoryOpen: isOpen,
    });
  };

  validEstimateJson = () => {
    if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
      const json = WINDOW.localStorage.getItem('mj_est');
      try{
        JSON.parse(json);
        return true;
      }
      catch (e) {
        return false;
      }
    }
    else{
      return false;
    }
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
    } else {
      // IE
      var evt = document.createEventObject();
      return element.fireEvent("on" + event, evt)
    }
  };

  handleResize = () => {
    if (this.open === false) return;
    //
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    let height = window.innerHeight - this.refs.heading.clientHeight;
    //let height = screen.availHeight - this.refs.heading.clientHeight;
    if (DOCUMENT.querySelector('.Header')) {
      if (top < 60) {
        height = height - (60 - top);
      }
    }
    this.setState({
      height: height,
    });
  };

  getPcHeading = () => {
    if (this.props.pcTitle && this.props.pcTitle !== '') {
      return this.props.pcTitle
    } else {
      if (this.props.rootLink && this.props.rootLink !== '') {
        if (this.props.rootLink.pcText && this.props.rootLink.pcText !== '') {
          return this.props.rootLink.pcText
        } else if (this.props.rootLink.pageName && this.props.rootLink.pageName !== '') {
          return this.props.rootLink.pageName
        }
      }
    }
    return null
  };

  getMbHeading = () => {
    if (this.props.mbTitle && this.props.mbTitle !== '') {
      return this.props.mbTitle
    } else if (this.props.pcTitle && this.props.pcTitle !== '') {
      return this.props.pcTitle
    } else {
      if (this.props.rootLink !== null) {
        if (this.props.rootLink.mbText && this.props.rootLink.mbText !== '') {
          return this.props.rootLink.mbText
        } else if (this.props.rootLink.pcText && this.props.rootLink.pcText !== '') {
          return this.props.rootLink.pcText
        } else if (this.props.rootLink.pageName && this.props.rootLink.pageName !== '') {
          return this.props.rootLink.pageName
        }
      }
    }
    return null
  };

  changeOpenClose = (e) => {
    e.preventDefault();
    if (this.open === true) {
      this.open = false;
      this.setState({
        open: false,
      });
      // BODYのスクロール無効化を解除
      BodyControl.clearUnScroll();
      //
      if (this.props.onClosed) this.props.onClosed();
    } else {
      this.open = true;
      this.setState({
        open: true,
      });
      //
      this.handleResize();
      // BODYのスクロール無効化
      BodyControl.setUnScrollMb();
      //
      if (this.props.onOpened) this.props.onOpened();
    }
  };

  setEstimateCount = () => {
    let cnt = 0;
    let est = {};

    if(!this.validEstimateJson()){
      return false;
    }

    if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
      const json = WINDOW.localStorage.getItem('mj_est');
      est = JSON.parse(json);
    }
    if (est && Object.keys(est).length > 0 && 'unsaved' in est && Array.isArray(est['unsaved']) && est['unsaved'].length > 0) {
      cnt += est['unsaved'].length;
    }
    if (est && Object.keys(est).length > 0 && 'saved' in est && Array.isArray(est['saved']) && est['saved'].length > 0) {
      cnt += est['saved'].length;
    }
    const estimationCount = this.refs.estimationCount;
    if (estimationCount) {
      estimationCount.classList.add('n' + cnt);
    }
  };

  render() {
    return (
      <div className={'SubNavigation__mb' + ((this.state.open === true) ? ' open': '')}>
        <div className={'SubNavigation__heading' + ((this.props.carsTitle === true) ? ' carsTitle': '')} ref='heading'>
          <a className="SubNavigation__heading-link" href="#"
             onClick={(e) => {
               this.changeOpenClose(e)
             }}
          >
            <h3 className="SubNavigation__heading-pc">
              <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getPcHeading())}}/>
            </h3>
            <h3 className="SubNavigation__heading-mb">
              <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbHeading())}}/>
            </h3>
            <span className="SubNavigation__heading-icon"/>
            <span className="SubNavigation__heading-text">MENU</span>
          </a>
        </div>
        <div className="SubNavigation__pull-down" style={{height: this.state.height}} ref='pulldown'>
          <div className="SubNavigation__pull-down-inner">
            {(() => {
              // Rootページへのリンク
              if (!this.props.deleteRootPageLink && this.props.rootLink !== null && this.props.rootLink.href !== null) {
                return (
                  <a className={'SubNavigation__link-root' + ((this.props.carsTitle === true) ? ' carsTitle': '') + ((this.props.hierarchy <= 1) ? ' current': '')}
                     href={this.props.rootLink.href}
                     target={(this.props.rootLink.external === true) ? '_blank': ''}
                  >
                    <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbHeading() + ' TOP')}}/>
                  </a>
                )
              } else {
                return null;
              }
            })()}
            {(() => {
              // 第2階層リンク以降
              if (this.props.links !== null && 1 <= this.props.links.length) {
                return (
                  <ul className="SubNavigation__list-ul">
                    {this.props.links.map((link, index) => {
                      return (
                        <li key={index}>
                          {(() => {
                            if (link.nestedNavigation !== null && link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
                              return (
                                <Accordion pageName={link.pageName}
                                           pcText={link.pcText}
                                           mbText={link.mbText}
                                           open={link.current}
                                           current={link.current}
                                           simpleAnimation={true}
                                >
                                  <SubNavigationLinks topLink={link.nestedNavigation.topLink}
                                                      links={link.nestedNavigation.links}
                                                      current={link.current}
                                  />
                                </Accordion>
                              )
                            } else {
                              return (
                                <SubNavigationLink pageName={link.pageName}
                                                   pcText={link.pcText}
                                                   mbText={link.mbText}
                                                   href={link.href}
                                                   external={link.external}
                                                   current={link.current}
                                                   onClick={null}
                                />
                              )
                            }
                          })()}
                        </li>
                      )
                    })}
                  </ul>
                )
              } else {
                return null
              }
            })()}
            {(() => {
              let estimationHistory = this.props.estimationHistory;
              if (estimationHistory != null && estimationHistory.length > 0 && this.validEstimateJson()) {
                let text = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationTitle && estimationHistory[0].props.navigationTitle !== '' ? estimationHistory[0].props.navigationTitle: '';
                let icon = estimationHistory[0] && estimationHistory[0].props && estimationHistory[0].props.navigationIcon && estimationHistory[0].props.navigationIcon !== '' ? estimationHistory[0].props.navigationIcon: '';
                return (
                  <div className="SubNavigation__estimation-history__button">
                    <a href='javascript:void(0)' className="SubNavigation__estimation-history__button__link"
                       onClick={this.onClickEstimationHistory}
                    >
                      <span className="SubNavigation__estimation-history__button__link__label">{text}</span>
                      <span className="SubNavigation__estimation-history__button__link__icon-container">
                        <img className="SubNavigation__estimation-history__button__link__icon" src={icon}/>
                        <span className="SubNavigation__estimation-history__button__link__count" ref='estimationCount'></span>
                      </span>
                    </a>
                  </div>
                )
              }
            })()}
          </div>
        </div>
        {(() => {
          let estimationHistory = this.props.estimationHistory;
          if (estimationHistory != null && estimationHistory.length > 0 && this.validEstimateJson()) {
            return (
              <div
                className={"SubNavigation__estimation-history" + (this.state.estimationHistoryOpen === true ? ' open': '')}
                ref='estimationHistory'>
                <div className="SubNavigation__estimation-history__inner">
                  {estimationHistory}
                </div>
                <div className="SubNavigation__estimation-history__close">
                  <a href='javascript:void(0)'
                     onClick={this.onClickEstimationHistory}
                     className="SubNavigation__estimation-history__close__button"
                  >close</a>
                </div>
              </div>
            )
          }
        })()}
      </div>
    )
  }

}

export default SubNavigationMb;

/**
 * SubNavigationLinks
 */
class SubNavigationLinks extends Component {

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      isMounted: false,
    }
  }

  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }

  render() {

    const topLink = this.props.topLink;
    const links = this.props.links;
    const current = this.props.current;

    return (
      <ul className="SubNavigation__list-ul2">
        {(() => {
          if (topLink !== null) {
            // TOPリンク
            if (this.state.isMounted) {

              // 下層にcurrentがある場合はTOPリンクはcurrentにしない
              let current = (topLink.href === location.pathname) ? true : topLink.current;
              let i, max;
              for (i = 0, max = links.length; i < max; i = i + 1) {
                if (links[i].current === true) {
                  current = false;
                  break;
                }
              }

              return (
                <li>
                  <SubNavigationLink
                    pageName={(topLink.pageName !== null) ? topLink.pageName + ' TOP' : null}
                    pcText={(topLink.pcText !== null) ? topLink.pcText + ' TOP' : null}
                    mbText={(topLink.mbText !== null) ? topLink.mbText + ' TOP' : null}
                    href={topLink.href}
                    external={topLink.external}
                    current={current}
                    onClick={null}
                  />
                </li>
              )
            } else {
              return (
                <li>
                  <SubNavigationLink
                    pageName={(topLink.pageName !== null) ? topLink.pageName + ' TOP' : null}
                    pcText={(topLink.pcText !== null) ? topLink.pcText + ' TOP' : null}
                    mbText={(topLink.mbText !== null) ? topLink.mbText + ' TOP' : null}
                    href={topLink.href}
                    external={topLink.external}
                    current={topLink.current}
                    onClick={null}
                  />
                </li>
              )
            }
          } else {
            return null
          }
        })()}
        {links.map((link, index) => {
          // リンク
          return (
            <li key={index}>
              {(() => {
                if (link.nestedNavigation !== null && link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
                  return (
                    <Accordion
                      pageName={link.pageName}
                      pcText={link.pcText}
                      mbText={link.mbText}
                      open={link.current}
                      current={link.current}
                      simpleAnimation={true}
                    >
                      <SubNavigationLinks
                        topLink={link.nestedNavigation.topLink}
                        links={link.nestedNavigation.links}
                      />
                    </Accordion>
                  )
                } else {
                  return (
                    <SubNavigationLink
                      pageName={link.pageName}
                      pcText={link.pcText}
                      mbText={link.mbText}
                      href={link.href}
                      external={link.external}
                      current={link.current}
                      onClick={null}
                    />
                  )
                }
              })()}
            </li>
          )
        })}
      </ul>
    )
  }

};

/**
 * SubNavigationLink
 */
const SubNavigationLink = ({
                             pageName,
                             pcText,
                             mbText,
                             href,
                             external,
                             current,
                             onClick,
                           }) => {
  const getPcText = () => {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  const getMbText = () => {
    if (mbText && mbText !== '') {
      return mbText;
    } else if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  const handleClick = (e) => {
    if (onClick !== null && typeof onClick === 'function') {
      e.preventDefault();
      onClick(e);
    }
  };
  return (
    <a className={'SubNavigation__link' + ((current === true) ? ' current': '')} href={href}
       target={(external === true) ? '_blank': ''}
       onClick={(e) => {
         handleClick(e)
       }}
    >
      <span className="SubNavigation__link-container">
        <span className="SubNavigation__link-pc">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
        </span>
        <span className="SubNavigation__link-mb">
          <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
        </span>
      </span>
      <span className="SubNavigation__link-border"/>
    </a>
  )
};



// WEBPACK FOOTER //
// ./src/containers/sub-navigation/mb.jsx